import { ReactNode } from 'react';

import { Grid } from '@mui/material';

import styles from './LoginModuleWrapper.module.scss';

interface LoginModuleWrapperI {
  logoUrl?: string;
  children: ReactNode;
}

const LoginModuleWrapper = ({ children }: LoginModuleWrapperI) => {
  return (
    <div className={styles.containers}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5}>
          <div className={styles.logoWrapper}>
            <img src={"https://static.wixstatic.com/media/d8fded_81c3bab6c50a4faa89edb560c844c47a%7Emv2.png/v1/fill/w_192%2Ch_192%2Clg_1%2Cusm_0.66_1.00_0.01/d8fded_81c3bab6c50a4faa89edb560c844c47a%7Emv2.png"} />
          </div>
        </Grid>
        <Grid item xs={12} md={7}>
          <div className={styles.content}>{children}</div>
        </Grid>
      </Grid>
    </div>
  );
};

export default LoginModuleWrapper;
